import React, { useEffect, useRef, useState } from "react";
import Timeline from "./CustomTimeline";
import UrlTagExtractor from "../../ai/UrlTagExtractor";

const InteractionsModal = ({ interactionId, showModal, setShowModal }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const offcanvasref = useRef(null);

  const actions = {
    user_asked: "User Asked",
    classify_user_intent: "Classifying User Intent",
    search_knowledge_base: "Seaching Internal Knowledge Base",
    evaluate_search_results: "Evaluating Search Results",
    refine_search_query: "Refining Query",
    ask_user_for_clarification: "Clarifying",
    google_search: "Seaching on Google",
    url_context: "Fetching Data from the URL",
    final_response: "Sent Final Response",
    get_product_knowledge: "Fetching Product Knowledge",
    followup_requested: "Follow-up Requested",
    followup_sent: "Follow-up Sent",
  };

  const getActionIcon = (action, type) => {
    switch (action) {
      case "user_asked":
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M5 21C5 17.134 8.13401 14 12 14C15.866 14 19 17.134 19 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>{" "}
            </g>
          </svg>
        );
      case "classify_user_intent":
        return (
          <svg
            viewBox="0 0 24 24"
            data-name="025_SCIENCE"
            id="_025_SCIENCE"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <defs>
                <style>{`.cls-1{fill:#000000;}`}</style>
              </defs>
              <path
                className="cls-1"
                d="M6,9A3,3,0,1,1,9,6,3,3,0,0,1,6,9ZM6,5A1,1,0,1,0,7,6,1,1,0,0,0,6,5Z"
              ></path>
              <path
                className="cls-1"
                d="M12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,12,11Z"
              ></path>
              <path
                className="cls-1"
                d="M18,9a3,3,0,1,1,3-3A3,3,0,0,1,18,9Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,18,5Z"
              ></path>
              <path
                className="cls-1"
                d="M18,21a3,3,0,1,1,3-3A3,3,0,0,1,18,21Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,18,17Z"
              ></path>
              <path
                className="cls-1"
                d="M6,21a3,3,0,1,1,3-3A3,3,0,0,1,6,21Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,6,17Z"
              ></path>
              <rect
                className="cls-1"
                height="4.83"
                transform="translate(-3.73 9) rotate(-45)"
                width="2"
                x="8"
                y="6.59"
              ></rect>
              <rect
                className="cls-1"
                height="2"
                transform="translate(-1.97 13.24) rotate(-45)"
                width="4.83"
                x="12.59"
                y="8"
              ></rect>
              <rect
                className="cls-1"
                height="2"
                transform="translate(-7.97 10.76) rotate(-45)"
                width="4.83"
                x="6.59"
                y="14"
              ></rect>
              <rect
                className="cls-1"
                height="4.83"
                transform="translate(-6.21 15) rotate(-45)"
                width="2"
                x="14"
                y="12.59"
              ></rect>
            </g>
          </svg>
        );
      case "search_knowledge_base":
        return (
          <svg
            version="1.1"
            id="Icons"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <style type="text/css">
                {`.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
              </style>
              <path
                className="st0"
                d="M26,3H9C7.3,3,6,4.3,6,6v0c0,1.7,1.3,3,3,3h17v10"
              ></path>
              <path className="st0" d="M18,29H9c-1.7,0-3-1.3-3-3v0V6"></path>
              <line className="st0" x1="26" y1="6" x2="9" y2="6"></line>
              <line className="st0" x1="10" y1="9" x2="10" y2="29"></line>
              <path
                className="st0"
                d="M25.5,18.5c1.9,1.9,1.9,5.1,0,7c-0.5,0.5-1,0.8-1.6,1.1c-1.8,0.7-3.9,0.4-5.4-1.1c-1.9-1.9-1.9-5.1,0-7 S23.6,16.6,25.5,18.5z"
              ></path>
              <path
                className="st0"
                d="M26.5,24l3.9,3.6c0.8,0.8,0.8,2,0,2.8l0,0c-0.8,0.8-2,0.8-2.8,0l-3.5-3.5"
              ></path>
            </g>
          </svg>
        );
      case "get_product_knowledge":
        return (
          <svg
            height="200px"
            width="200px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 393.535 393.535"
            xmlSpace="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g>
                {" "}
                <path
                  style={{ fill: "#000000" }}
                  d="M380.973,316.791l-48.656-48.654c5.891-15.474,8.131-32.307,6.361-48.939 c-2.539-23.875-13.283-46.37-30.252-63.339c-8.418-8.417-18.018-15.228-28.426-20.292V77.111c0-3.934-1.56-7.706-4.344-10.484 l-58.875-58.88c-2.785-2.778-6.551-4.339-10.484-4.339H29.111C13.059,3.408,0,16.468,0,32.521v312.095 c0,16.053,13.059,29.113,29.111,29.113h221.777c16.053,0,29.111-13.06,29.111-29.113v-7.29l40.219,40.219 c8.115,8.114,18.902,12.582,30.377,12.582s22.262-4.469,30.377-12.582C397.723,360.794,397.723,333.541,380.973,316.791z M248.387,341.315H31.613V35.822h154.088v43.577c0,10.554,8.555,19.106,19.105,19.106h43.58v27.496 c-4.775-0.652-9.625-0.992-14.531-0.992c-28.191,0-54.676,10.956-74.568,30.85c-19.895,19.894-30.85,46.376-30.85,74.569 c0,28.193,10.955,54.676,30.85,74.569c19.893,19.894,46.373,30.85,74.566,30.85c4.887,0,9.74-0.336,14.533-0.997V341.315z M364.188,359.534c-7.014,7.014-18.385,7.014-25.398,0l-61.277-61.278c-31.064,19.492-72.648,15.738-99.654-11.269 c-31.371-31.37-31.371-82.413,0-113.783c31.369-31.37,82.412-31.37,113.783,0c27.006,27.006,30.76,68.591,11.268,99.654 l61.279,61.278C371.201,341.149,371.201,352.52,364.188,359.534z"
                ></path>{" "}
                <path
                  style={{ fill: "#000000" }}
                  d="M202.914,198.261c-17.554,17.554-17.554,46.115,0,63.669c17.554,17.553,46.114,17.553,63.67,0 c17.552-17.554,17.552-46.115,0-63.669C249.028,180.707,220.468,180.707,202.914,198.261z"
                ></path>{" "}
              </g>{" "}
            </g>
          </svg>
        );
      case "evaluate_search_results":
        return (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M16 1C17.6569 1 19 2.34315 19 4C19 4.55228 18.5523 5 18 5C17.4477 5 17 4.55228 17 4C17 3.44772 16.5523 3 16 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H16C16.5523 21 17 20.5523 17 20V19C17 18.4477 17.4477 18 18 18C18.5523 18 19 18.4477 19 19V20C19 21.6569 17.6569 23 16 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H16Z"
                fill="#0F0F0F"
              ></path>{" "}
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.7991 8.20087C20.4993 7.90104 20.0132 7.90104 19.7133 8.20087L11.9166 15.9977C11.7692 16.145 11.6715 16.3348 11.6373 16.5404L11.4728 17.5272L12.4596 17.3627C12.6652 17.3285 12.855 17.2308 13.0023 17.0835L20.7991 9.28666C21.099 8.98682 21.099 8.5007 20.7991 8.20087ZM18.2991 6.78666C19.38 5.70578 21.1325 5.70577 22.2134 6.78665C23.2942 7.86754 23.2942 9.61999 22.2134 10.7009L14.4166 18.4977C13.9744 18.9398 13.4052 19.2327 12.7884 19.3355L11.8016 19.5C10.448 19.7256 9.2744 18.5521 9.50001 17.1984L9.66448 16.2116C9.76728 15.5948 10.0602 15.0256 10.5023 14.5834L18.2991 6.78666Z"
                fill="#0F0F0F"
              ></path>{" "}
              <path
                d="M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7Z"
                fill="#0F0F0F"
              ></path>{" "}
              <path
                d="M5 11C5 10.4477 5.44772 10 6 10H10C10.5523 10 11 10.4477 11 11C11 11.5523 10.5523 12 10 12H6C5.44772 12 5 11.5523 5 11Z"
                fill="#0F0F0F"
              ></path>{" "}
              <path
                d="M5 15C5 14.4477 5.44772 14 6 14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H6C5.44772 16 5 15.5523 5 15Z"
                fill="#0F0F0F"
              ></path>{" "}
            </g>
          </svg>
        );
      case "google_search":
        return (
          <svg
            viewBox="-3 0 262 262"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
                fill="#4285F4"
              ></path>
              <path
                d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
                fill="#34A853"
              ></path>
              <path
                d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
                fill="#FBBC05"
              ></path>
              <path
                d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
                fill="#EB4335"
              ></path>
            </g>
          </svg>
        );
      case "followup_sent":
        return (
          <svg
            style={{ width: "32px", height: "32px" }}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
                fill="#00BA00"
              ></path>{" "}
            </g>
          </svg>
        );
      case "followup_requested":
        return (
          <svg
            fill="#000000"
            width="800px"
            height="800px"
            viewBox="0 0 16 16"
            id="request-16px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="Path_49"
              data-name="Path 49"
              d="M30.5,16a.489.489,0,0,1-.191-.038A.5.5,0,0,1,30,15.5V13h-.5A2.5,2.5,0,0,1,27,10.5v-8A2.5,2.5,0,0,1,29.5,0h11A2.5,2.5,0,0,1,43,2.5v8A2.5,2.5,0,0,1,40.5,13H33.707l-2.853,2.854A.5.5,0,0,1,30.5,16Zm-1-15A1.5,1.5,0,0,0,28,2.5v8A1.5,1.5,0,0,0,29.5,12h1a.5.5,0,0,1,.5.5v1.793l2.146-2.147A.5.5,0,0,1,33.5,12h7A1.5,1.5,0,0,0,42,10.5v-8A1.5,1.5,0,0,0,40.5,1ZM36,9a1,1,0,1,0-1,1A1,1,0,0,0,36,9Zm1-4a2,2,0,0,0-4,0,.5.5,0,0,0,1,0,1,1,0,1,1,1,1,.5.5,0,0,0,0,1A2,2,0,0,0,37,5Z"
              transform="translate(-27)"
            />
          </svg>
        );
      case "final_response":
        return (
          <svg
            style={{ width: "32px", height: "32px" }}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
                fill="#00BA00"
              ></path>{" "}
            </g>
          </svg>
        );
      // case "refine_search_query":
      // 	return <i className="fa fa-edit" aria-hidden="true"></i>;
      // case "ask_user_for_clarification":
      // 	return <i className="fa fa-comments" aria-hidden="true"></i>;
      // case "url_context":
      // 	return <i className="fa fa-link" aria-hidden="true"></i>;
      default:
        if (type === "user") {
          return <i className="fa fa-cogs" aria-hidden="true"></i>;
        } else {
          return (
            <svg
              viewBox="0 0 24.00 24.00"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#CCCCCC"
                stroke-width="0.096"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 2C14 2.74028 13.5978 3.38663 13 3.73244V4H20C21.6569 4 23 5.34315 23 7V19C23 20.6569 21.6569 22 20 22H4C2.34315 22 1 20.6569 1 19V7C1 5.34315 2.34315 4 4 4H11V3.73244C10.4022 3.38663 10 2.74028 10 2C10 0.895431 10.8954 0 12 0C13.1046 0 14 0.895431 14 2ZM4 6H11H13H20C20.5523 6 21 6.44772 21 7V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V7C3 6.44772 3.44772 6 4 6ZM15 11.5C15 10.6716 15.6716 10 16.5 10C17.3284 10 18 10.6716 18 11.5C18 12.3284 17.3284 13 16.5 13C15.6716 13 15 12.3284 15 11.5ZM16.5 8C14.567 8 13 9.567 13 11.5C13 13.433 14.567 15 16.5 15C18.433 15 20 13.433 20 11.5C20 9.567 18.433 8 16.5 8ZM7.5 10C6.67157 10 6 10.6716 6 11.5C6 12.3284 6.67157 13 7.5 13C8.32843 13 9 12.3284 9 11.5C9 10.6716 8.32843 10 7.5 10ZM4 11.5C4 9.567 5.567 8 7.5 8C9.433 8 11 9.567 11 11.5C11 13.433 9.433 15 7.5 15C5.567 15 4 13.433 4 11.5ZM10.8944 16.5528C10.6474 16.0588 10.0468 15.8586 9.55279 16.1056C9.05881 16.3526 8.85858 16.9532 9.10557 17.4472C9.68052 18.5971 10.9822 19 12 19C13.0178 19 14.3195 18.5971 14.8944 17.4472C15.1414 16.9532 14.9412 16.3526 14.4472 16.1056C13.9532 15.8586 13.3526 16.0588 13.1056 16.5528C13.0139 16.7362 12.6488 17 12 17C11.3512 17 10.9861 16.7362 10.8944 16.5528Z"
                  fill="#000000"
                ></path>
              </g>
            </svg>
          );
        }
    }
  };

  const getActionMessage = (data) => {
    if (!data.action) {
      return null;
    }

    return (
      <React.Fragment>
        <p>
          <strong>{actions[data.action] || data.action}</strong>
        </p>
        {(data.step == 0 || data.action == "user_asked") && (
          <p>{data.message}</p>
        )}
        {data.result && data.result.query && (
          <p>
            <strong>Query :</strong>
            {data.result.query}
          </p>
        )}
        {data.result && data.result.assessment ? (
          <p>
            <strong>Assessment: </strong>
            {data.result.assessment}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.reason_for_refinement && (
          <p>
            <strong>Reason for Refinement: </strong>
            {data.result.reason_for_refinement}
          </p>
        )}
        {data.result && data.result.refined_query && (
          <p>
            <strong>Refined Query: </strong>
            {data.result.refined_query}
          </p>
        )}
        {data.result && (data.result.intent || data.result.intent_code) ? (
          <p>
            <strong>Intent Detected: </strong>
            {data.result.intent || data.result.intent_code}
          </p>
        ) : (
          ""
        )}
        {data.result &&
        data.result.confidence !== undefined &&
        data.result.confidence !== null &&
        data.action !== "final_response" &&
        data.action !== "classify_user_intent" ? (
          <p>
            <strong>Confidence: </strong>
            {data.result.confidence}
          </p>
        ) : (
          ""
        )}
        {data.result &&
        data.result.confidence_score !== undefined &&
        data.result.confidence_score !== null &&
        data.action !== "final_response" &&
        data.action !== "classify_user_intent" ? (
          <p>
            <strong>Confidence: </strong>
            {data.result.confidence_score}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.resolved_tool ? (
          <p>
            <strong>Resolved Tool: </strong>
            {data.result.resolved_tool}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.tool_name ? (
          <p>
            <strong>Resolved Tool: </strong>
            {data.result.tool_name}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.response_kind ? (
          <p>
            <strong>Response Kind: </strong>
            {data.result.response_kind}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.response_type ? (
          <p>
            <strong>Response Type: </strong>
            {data.result.response_type}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.response_mode ? (
          <p>
            <strong>Response Mode: </strong>
            {data.result.response_mode}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.reasoning ? (
          <p>
            <strong>Reasoning: </strong>
            {data.result.reasoning}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.refusal_reason ? (
          <p>
            <strong>Refusal Reason: </strong>
            {data.result.refusal_reason}
          </p>
        ) : (
          ""
        )}
        {data.result && data.result.reason ? (
          <p>
            <strong>Reason: </strong>
            {data.result.reason}
          </p>
        ) : (
          ""
        )}
        {data.result &&
        data.result.product_slugs &&
        data.result.product_slugs.length > 0 ? (
          <p>
            <strong>Products: </strong>
            <React.Fragment>
              <ul>
                {data.result.product_slugs.map((product, index) => {
                  return (
                    <li>
                      <p key={index}>{product || ""}</p>
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          </p>
        ) : (
          ""
        )}
        {data.result &&
        data.result.page_type_priority &&
        data.result.page_type_priority.length > 0 ? (
          <p>
            <strong>Page Types: </strong>
            <React.Fragment>
              <ul>
                {data.result.page_type_priority.map((type, index) => {
                  return (
                    <li>
                      <p key={index}>{type || ""}</p>
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          </p>
        ) : (
          ""
        )}
        {data.result &&
        data.result.web_search_queries &&
        data.result.web_search_queries.length > 0 ? (
          <p>
            <strong>Queries: </strong>
            <React.Fragment>
              <ul>
                {data.result.web_search_queries.map((query, index) => {
                  return (
                    <li>
                      <p key={index}>{query || ""}</p>
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          </p>
        ) : (
          ""
        )}
        {data.result &&
          data.result.documents &&
          data.result.documents.length > 0 &&
          data.action !== "final_response" && (
            <React.Fragment>
              <p>
                <strong>Documents: </strong>
              </p>
              <ol>
                {data.result.documents.map((doc, index) => {
                  return (
                    <li key={index}>
                      <p>
                        <a
                          href={doc.document_url || ""}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {doc.document_title || ""}
                        </a>
                      </p>
                    </li>
                  );
                })}
              </ol>
            </React.Fragment>
          )}
        {data.result &&
          data.result.items &&
          data.result.items.length > 0 &&
          data.action !== "final_response" && (
            <React.Fragment>
              <p>
                <strong>Documents: </strong>
              </p>
              <ol>
                {data.result.items.map((item, index) => {
                  return (
                    <li key={index}>
                      <p>
                        <a
                          href={item.source_url || ""}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.page_title || ""}
                        </a>
                      </p>
                      {item &&
                        item.metadata &&
                        item.metadata.hierarchy &&
                        item.metadata.hierarchy.taxonomy_path &&
                        item.metadata.hierarchy.taxonomy_path.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            {item.metadata.hierarchy.taxonomy_path.map(
                              (path, index) => (
                                <span
                                  style={{
                                    padding: "2px 8px",
                                    borderRadius: "4px",
                                    fontSize: "10px",
                                    fontWeight: 700,
                                    backgroundColor: "rgb(245, 245, 245)",
                                    color: "rgb(97, 97, 97)",
                                    border: "1px solid rgb(224, 224, 224)",
                                    textTransform: "uppercase",
                                    margin: "2px 0px",
                                  }}
                                  key={index}
                                >
                                  {path}
                                </span>
                              ),
                            )}
                          </div>
                        )}
                    </li>
                  );
                })}
              </ol>
            </React.Fragment>
          )}
        {data.result &&
          data.result.citations &&
          data.result.citations.length > 0 &&
          data.action !== "final_response" && (
            <React.Fragment>
              <p>
                <strong>Documents: </strong>
              </p>
              <ol>
                {data.result.citations.map((doc, index) => {
                  return (
                    <li key={index}>
                      <p>
                        <a
                          href={doc.source_url || ""}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {doc.page_title || ""}
                        </a>
                      </p>
                    </li>
                  );
                })}
              </ol>
            </React.Fragment>
          )}
        {data.result &&
          data.result.candidates &&
          data.result.candidates.length > 0 &&
          data.result.candidates[0].groundingMetadata &&
          data.result.candidates[0].groundingMetadata.groundingChunks && (
            <React.Fragment>
              <p>
                <strong>Searched Links:</strong>
              </p>
              <ol>
                {data.result.candidates[0].groundingMetadata.groundingChunks.map(
                  (doc, index) => {
                    if (!doc.web || !doc.web.uri || !doc.web.title) {
                      return null;
                    }
                    return (
                      <li key={index}>
                        <p>
                          <a
                            href={doc.web.uri}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {doc.web.title}
                          </a>
                        </p>
                      </li>
                    );
                  },
                )}
              </ol>
            </React.Fragment>
          )}
        {data.result &&
          data.result.candidates &&
          data.result.candidates.length > 0 &&
          data.result.candidates[0].groundingMetadata &&
          data.result.candidates[0].groundingMetadata.webSearchQueries && (
            <React.Fragment>
              <p>
                <strong>Search Queries:</strong>
              </p>
              <ol>
                {data.result.candidates[0].groundingMetadata.webSearchQueries.map(
                  (query, index) => {
                    if (!query) {
                      return null;
                    }
                    return (
                      <li key={index}>
                        <p>{query}</p>
                      </li>
                    );
                  },
                )}
              </ol>
            </React.Fragment>
          )}
        {data.action == "get_product_knowledge" &&
        data.result &&
        data.result.name ? (
          <p>
            <strong>Product Recommended: </strong>
            {data.result.name}
          </p>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  };

  useEffect(() => {
    document.addEventListener("mousedown", (e) => {
      if (offcanvasref.current && !offcanvasref.current.contains(e.target)) {
        offCanvas();
      }
    });

    return () => {
      document.removeEventListener("mousedown", () => {});
    };
  }, []);

  useEffect(() => {
    if (!interactionId) {
      setData([]);
      return;
    }

    fetchData();
  }, [interactionId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CRM}/ai/interactions/${interactionId}`
      );
      const result = await response.json();
      console.log("interaction result", result);
      if (response.ok && result.data) {
        setData(result.data || []);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const offCanvas = () => {
    setShowModal(false);
  };

  return (
    <React.Fragment>
      <div
        class="col-md-3 chat-padding-0 offcanvas-impl interactions-canvas"
        style={{
          zIndex: 1050,
          position: "absolute",
          right: 0,
          top: 0,
        }}
      >
        <div
          class="offcanvas offcanvas-start"
          tabindex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
          style={{
            transform: `${showModal ? "translateX(-18%)" : "translateX(100%)"}`,
          }}
          ref={offcanvasref}
        >
          <div className="close-times">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#000"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
              width="22px"
              onClick={offCanvas}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16px"
                  height="16px"
                  viewBox="0 0 50 50"
                >
                  <path d="M49.04,24.001l-1.082-0.043h-0.001C36.134,23.492,26.508,13.866,26.042,2.043L25.999,0.96C25.978,0.424,25.537,0,25,0	s-0.978,0.424-0.999,0.96l-0.043,1.083C23.492,13.866,13.866,23.492,2.042,23.958L0.96,24.001C0.424,24.022,0,24.463,0,25	c0,0.537,0.424,0.978,0.961,0.999l1.082,0.042c11.823,0.467,21.449,10.093,21.915,21.916l0.043,1.083C24.022,49.576,24.463,50,25,50	s0.978-0.424,0.999-0.96l0.043-1.083c0.466-11.823,10.092-21.449,21.915-21.916l1.082-0.042C49.576,25.978,50,25.537,50,25	C50,24.463,49.576,24.022,49.04,24.001z"></path>
                </svg>
              </span>
              Source
            </h5>
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div class="offcanvas-body">
            {/* {getFormatData(infoData)} */}
            {loading ? (
              <div>
                <p style={{ padding: "10px" }}>Loading...</p>
              </div>
            ) : !data || data.length < 0 ? (
              <div style={{ padding: "10px" }}>No Interactions Found</div>
            ) : (
              <div style={{ padding: "10px" }}>
                <Timeline className="custom-timeline">
                  {data.map((item) => {
                    return (
                      <Timeline.Item
                        key={item.id}
                        dot={getActionIcon(item.action, item.type)}
                      >
                        {getActionMessage(item)}
                      </Timeline.Item>
                    );
                  })}
                </Timeline>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default InteractionsModal;



// WEBPACK FOOTER //
// ./src/components/chat/components/InteractionsModal.js